import type { RibbonControlProps } from "owa-acui";
import { owaComputedFn } from "owa-computed-fn";
import { type MailRibbonControlId, type MailRibbonTabId } from "owa-ribbon-ids/lib/mailRibbonId";
import type { RibbonControlId } from "owa-ribbon-ids";
import type { ReadOnlyRibbonControlDefProps } from "owa-mail-ribbon-utils";
import { getMessagesControl, getLayoutControl } from "./slrViewTabControlDefinitions";
import { getDensityControl, getRibbonCustomizerControl, getViewSettingsControl, getRemindersWindowControl, getExpandCollapseConversationControl, getSyncMailboxControl, getFolderPaneControl, getLightRPControl, getFocusedInboxToggleControl, } from "../../sharedControls/readSharedControlDefinitions";
import { getImmersiveReaderControl, getZoomControl, } from "../../sharedControls/readProjectionSharedControlDefinitions";
import { logUsage } from "owa-analytics";
import { debugErrorThatWillShowErrorPopupOnly } from "owa-trace";
import { getRibbonMailboxInfo } from "owa-mail-ribbon-utils/lib/getRibbonMailboxInfo";

/**
 * This function supplies a mapping from RibbonControlId to their respective control definition function.
 * For any new control in a tab, be sure to update the mapping below.
 * Note: This function should *not* have any logic regarding showing/hiding.
 *       That should be in shouldShowRibbonControl.ts instead.
 */
export const getSLRViewTabControlDefinition: (controlId: RibbonControlId, _tabId: MailRibbonTabId, props: ReadOnlyRibbonControlDefProps) => RibbonControlProps | undefined = owaComputedFn(function getSLRViewTabControlDefinition(controlId: RibbonControlId, _tabId: MailRibbonTabId, props: ReadOnlyRibbonControlDefProps): RibbonControlProps | undefined {
    switch (controlId) {
        case 649:
            return getDensityControl(true /*isSLR*/, 3, props);
        case 647:
            return getFolderPaneControl(true /*isSLR */, 3, props);
        case 532:
            return getImmersiveReaderControl(true /*isSLR*/, 3, props);
        case 654:
            return getMessagesControl(props);
        case 646:
            return getLayoutControl(props);
        case 558:
            return getRibbonCustomizerControl(3, props);
        case 643:
            return getViewSettingsControl(true /*isSLR*/, 3, props);
        case 690:
            return getRemindersWindowControl(true /*isSLR*/, 3, props);
        case 687:
            return getExpandCollapseConversationControl(props);
        case 688:
            return getZoomControl(true /*isSLR*/, 3, props);
        case 701:
            return getSyncMailboxControl(true /*isSLR*/, 3, props);
        case 720:
            return getLightRPControl(props);
        case 774:
            return getFocusedInboxToggleControl(props);
        default:
            const mailboxInfo = getRibbonMailboxInfo(props.mailboxInfo);
            
            debugErrorThatWillShowErrorPopupOnly("getSLRViewTabControlDefinition UnknownControl: " + controlId);
            
            logUsage("SLRViewTabControlDefinitionUnknownControl", mailboxInfo, {
                controlId,
                stack: new Error("SLRViewTabControlDefinitionUnknownControl").stack,
            });
            return undefined;
    }
});
